import { CodeSyntax } from '@carbon/pictograms-react';
import { NetworkServices } from '@carbon/pictograms-react';
import { CarbonForIbmDotcom } from '@carbon/pictograms-react';
import { Kubernetes } from '@carbon/pictograms-react';
import * as React from 'react';
export default {
  CodeSyntax,
  NetworkServices,
  CarbonForIbmDotcom,
  Kubernetes,
  React
};